import axios from "axios";
import { BASE_API_V1_URL } from "neetocommons/constants";

const fetchStickyRibbons = () =>
  axios.get(`${BASE_API_V1_URL}/sticky_ribbons`, {
    includeMetadataInResponse: true,
  });

const stickyRibbonsApi = { fetchStickyRibbons };

export default stickyRibbonsApi;
